<template>
  <div class="period">
    <dl>
      <dt>조회기간</dt>
      <dd>{{ startDate }} ~ {{ endDate }}</dd>
    </dl>
    <button
      type="button"
      @click="$store.dispatch('datepicker/setOpenRadio', !isOpenRadio)"
    >
      조회설정
      <span
        class="icon"
        :class="[isOpenRadio ? 'iconUp2' : 'iconDown2']"
      ></span>
    </button>
    <ul class="periodRadio" v-if="isOpenRadio">
      <li>
        <form-radio
          id="periodRadio1"
          name="periodRadio"
          labelText="1개월"
          :checked="!isOpenSelect && 1 === month"
          @handleCheck="handleCheck(1)"
        ></form-radio>
      </li>
      <li>
        <form-radio
          id="periodRadio3"
          name="periodRadio"
          labelText="3개월"
          :checked="!isOpenSelect && 3 === month"
          @handleCheck="handleCheck(3)"
        ></form-radio>
      </li>
      <li>
        <form-radio
          id="periodRadio6"
          name="periodRadio"
          labelText="6개월"
          :checked="!isOpenSelect && 6 === month"
          @handleCheck="handleCheck(6)"
        ></form-radio>
      </li>
      <li>
        <form-radio
          id="periodRadioAll"
          name="periodRadio"
          labelText="기간검색"
          :checked="isOpenSelect"
          @handleCheck="handleCheck"
        ></form-radio>
      </li>
    </ul>
    <ul class="periodSelect" v-if="isOpenSelect">
      <li>
        <select v-model="selectedYear">
          <option v-for="(el, idx) in yearArr" :key="idx" :value="el">
            {{ el }}년
          </option>
        </select>
      </li>
      <li>
        <select v-model="selectedMonth">
          <option disabled value="0">선택하세요</option>
          <option v-for="(el, idx) in monthArr" :key="idx" :value="el">
            {{ el }}월
          </option>
        </select>
      </li>
    </ul>
  </div>
</template>

<script>
import FormRadio from '@/views/base/FormRadio'
import { mapActions, mapGetters } from 'vuex'
import { getYYYYMMDD } from '@/utils'

export default {
  name: 'FormDateRange',
  components: {
    FormRadio
  },
  watch: {
    isOpenRadio: {
      handler(n, o) {
        this.$store.dispatch('datepicker/setOpenSelect', false)
      }
    },
    month: {
      handler(n, o) {
        if (n && this.isOpenSelect) {
          this.$store.dispatch('datepicker/setOpenSelect', false)
        }
      }
    },
    date: {
      handler(n, o) {
        if (n && this.isDateAvailable) {
          this.$emit('changeDate')
        }
      }
    },
    selectedYear: {
      handler(n, o) {
        if (n) {
          this.selectedMonth = 0
        }
      }
    },
    isOpenSelect: {
      handler(n, o) {
        if (n === false) {
          // 셀렉트 박스가 감추어 질때
          this.selectedMonth = 0
          this.selectedYear = this.yearArr[0]
        }
      }
    },
    selectedMonth: {
      handler(n, o) {
        if (n && this.isSelectedDateAvailable) {
          // 셀렉트의 년도와 달을 선택하면 검색을 시작한다.
          const selectedYearMonth = `${this.selectedYear}-${
            this.selectedMonth < 10
              ? '0' + this.selectedMonth
              : this.selectedMonth
          }-`

          const now = new Date()
          const fiveYearsAgo = now.getFullYear() - 5

          // selected year가 5년전이면서 달도 같으면 오늘 날짜 아니면 01
          let currentDate = '01'

          if (
            this.selectedYear === fiveYearsAgo &&
            this.selectedMonth === now.getMonth() + 1
          ) {
            currentDate = now.getDate()
            if (currentDate < 10) {
              currentDate = '0' + currentDate
            }
          }

          this.$store.dispatch('datepicker/setDateNMonth', {
            startDate: selectedYearMonth + currentDate,
            endDate:
              selectedYearMonth +
              new Date(this.selectedMonth, this.selectedMonth, 0).getDate()
          })
        }
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters('datepicker', [
      'isOpenRadio',
      'isOpenSelect',
      'startDate',
      'endDate',
      'month',
      'yearArr',
      'selectedYear'
    ]),
    ...mapGetters('main', ['requestPossible']),
    isDateAvailable() {
      return this.startDate.length > 0 && this.endDate.length > 0
    },
    isSelectedDateAvailable() {
      return this.selectedYear > 0 && this.selectedMonth > 0
    },
    date() {
      return { startDate: this.startDate, endDate: this.endDate }
    },
    monthArr() {
      const now = new Date()
      const year = now.getFullYear()
      const result = []
      const fiveYearsAgo = year - 5

      let month = 12
      let minMonth = 0

      if (this.selectedYear === year) {
        // 올해일 경우 현재 월부터 하나씩 줄여 나가서 표기한다.
        month = now.getMonth() + 1
      } else if (this.selectedYear === fiveYearsAgo) {
        // 5년전일 경우 12월부터 현재 월까지 하나씩 줄여 나가서 표기한다.
        minMonth = now.getMonth()
      }

      do {
        result.push(month)
        month--
      } while (month > minMonth)

      return result
    },
    selectedYear: {
      get() {
        return this.$store.getters['datepicker/selectedYear']
      },
      set(value) {
        this.$store.dispatch('datepicker/setSelectedYear', value)
      }
    },
    selectedMonth: {
      get() {
        return this.$store.getters['datepicker/selectedMonth']
      },
      set(value) {
        this.$store.dispatch('datepicker/setSelectedMonth', value)
      }
    }
  },
  methods: {
    handleCheck(month) {
      this.$store.dispatch('datepicker/setOpenSelect', month ? false : true)
      if (month) {
        this.$store.dispatch('datepicker/setDateNMonth', {
          month: month,
          startDate: getYYYYMMDD(month),
          endDate: getYYYYMMDD()
        })
      }
    }
  },
  mounted() {
    if (this.isDateAvailable === false) {
      this.$store.dispatch('datepicker/setDateNMonth', {
        month: 1,
        startDate: getYYYYMMDD(1),
        endDate: getYYYYMMDD()
      })
    }
  }
}
</script>
